import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren, StrictMode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { RecoilRoot } from 'recoil';

import CssBaseline from '@mui/material/CssBaseline';

import { AppThemeProvider } from '@/app/theme';
import { store } from '@/app/store';

import AuthProvider from './session-provider';

const queryClient = new QueryClient();

const AppProviders = ({ children }: PropsWithChildren) => (
  <StrictMode>
    <RecoilRoot>
      <HelmetProvider>
        <AppThemeProvider>
          <ReduxProvider store={store}>
            <QueryClientProvider client={queryClient}>
              <CssBaseline />
              <AuthProvider>{children}</AuthProvider>
            </QueryClientProvider>
          </ReduxProvider>
        </AppThemeProvider>
      </HelmetProvider>
    </RecoilRoot>
  </StrictMode>
);

export default AppProviders;
